//
//
//
//
//
//
export default {
  name: 'FibBackButton',
  props: {
    callback: {
      type: Function,
      default: null
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.back();
    },
    handleClick: function handleClick() {
      if (this.callback) {
        this.callback();
      } else {
        this.goBack();
      }
    }
  }
};